import { render, staticRenderFns } from "./special_menu_list.vue?vue&type=template&id=44aaf313"
import script from "./special_menu_list.vue?vue&type=script&lang=js"
export * from "./special_menu_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports